import * as React from 'react'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {api} from '../api/api'
import '../css/retention.css'
import {tagger} from '../util/util'
import { locales } from '../util/locales'

const Retention = () => {

    const {t} = useTranslation('landing')

    const [posts, setPosts] = useState([])

    const loadData = async () => {
        const itemsNumber = window.innerWidth > 1104 ? 5 : 3
        const blogResult = await api.blog(itemsNumber)
        setPosts(blogResult)
    }

    useEffect(() => {
        loadData()
    }, [])

    const renderPost = (post, i) => {

        const options = {
            hour12: false,
            timeZone: 'UTC',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }

        return (
            <a href={post.post_url} key={i} className="post-item">
                <img className="post-image" src={post.preview_image_url} />
                <div className="post-description">
                    <div className="post-title">{post.title}</div>
                    <div className="post-author">{post.author.name} • {new Date(post.publish_date).toLocaleDateString(locales.enUS, options)}{/* • 4 min read*/}</div>
                </div>
            </a>
        )
    }

    const renderPostList = () => posts.map((post, i) => renderPost(post, i))

    return (
        <div className="blog" ><p className="muli">{tagger(t('The Weekly R'), 'accent-text')}</p>
            <div>
                <p>{t('Get the latest i')}</p>
                <div className="posts">
                    {renderPostList()}
                </div>
            </div>
        </div>
    )

}

export default Retention


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/retention.tsx